import React, { useState, useEffect, useRef } from "react";
import { Header } from "../components/Header.js";
import { Footer } from "../components/Footer.js";
import { Slide_title } from "../components/slide-title.js";
import { Link, useNavigate } from "react-router-dom";
import upload from "./../assets/img/upload.svg";
import disc from "./../assets/img/disc.svg";
import remove from "./../assets/img/remove.svg";
import PdfIcon from "../assets/img/pdf.png";
import {
  addtocart_get_api,
  addtocart_delete_api,
  gstdata_get_api,
  cart_description_api,
  cart_artwork_api,
  delete_artwork_api,
  get_cart_count,
  guest_addtocart_get_api,
  guest_addtocart_delete_api,
  guest_gstdata_get_api,
  guest_cart_description_api,
  guest_cart_artwork_api,
  guest_delete_artwork_api,
  guest_get_cart_count,
} from "../service/api.js";
import ErrorSnackbar from "../components/ErrorSnackbar.js";
import SuccessSnackbar from "../components/SuccessSnackbar.js";
import Head_CateHead from "../components/Head_CateHead.js";
import Alert from "../components/Alert.js";
import CartVariationInfo from "../components/CartVariationInfo.js";
import { CartSkeleton } from "../components/Skeleton.js";

export const Cart = () => {
  const navigate = useNavigate();
  const isGuest = !localStorage.getItem("token");

  const [api_data, setapi_data] = useState([]);
  const [cartLoading, setCartLoading] = useState(true);
  const [ExceptionError, setExceptionError] = useState([]);
  const [successMessages, setSuccessMessages] = useState([]);
  const fileInputRef = useRef(null);
  const [cartData, setCartData] = useState(localStorage.getItem("cartItemCount") || 0);
  const [expandedShirt, setExpandedShirt] = useState({});

  function handleExceptionError(res) {
    setExceptionError((prev) => [...prev, { id: Date.now(), message: res }]);
  }
  function handleExceptionSuccessMessages(res) {
    setSuccessMessages((prev) => [...prev, { id: Date.now(), message: res.Message }]);
  }
  function clearErrors(id) {
    setExceptionError((prev) => prev.filter((msg) => msg.id !== id));
  }
  function clearSuccess(id) {
    setSuccessMessages((prev) => prev.filter((msg) => msg.id !== id));
  }

  // Normalise API response into a consistent shape:
  // Each item always has a `Carts` array with entries that have CartID, QTY, BasePrice,
  // ProductName, randomnumber, CartSetupPrice, CartAttachment, Brief, ShirtDescription, custompopup
  const normaliseData = (rawData, guest) => {
    if (!Array.isArray(rawData)) return [];
    return rawData.map((item) => {
      const carts = guest
        ? (item.GuestCarts || []).map((c) => ({
            CartID: c.GuestCartID,
            ProductName: c.ProductName,
            QTY: c.QTY,
            BasePrice: c.BasePrice,
            randomnumber: c.randomnumber,
            CartSetupPrice: c.GuestCartSetupPrice || [],
            CartAttachment: (c.GuestCartAttachment || []).map((a) => ({
              CartAttachmentID: a.GuestCartAttachmentID,
              Attachment: a.Attachment,
            })),
            Brief: c.Brief,
            ShirtDescription: c.ShirtDescription,
            custompopup: c.custompopup,
            VariationName: c.VariationName,
            VariationAttributes: c.VariationAttributes,
          }))
        : item.Carts || [];
      return { ...item, Carts: carts };
    });
  };

  const fetchData = async () => {
    try {
      const cartApiData = isGuest
        ? await guest_addtocart_get_api()
        : await addtocart_get_api();

      const raw = cartApiData.Data;
      if (Array.isArray(raw) && raw.length === 0) {
        navigate("/");
        return;
      }
      setapi_data(normaliseData(raw, isGuest));
      fetchGST();
    } catch (error) {
      console.error("Error fetching cart:", error);
    } finally {
      setCartLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // Refresh when an item is removed from the cart sidebar
    const refresh = () => fetchData();
    window.addEventListener("cart-updated", refresh);
    return () => window.removeEventListener("cart-updated", refresh);
  }, []);

  const [showConfirmBox, setShowConfirmBox] = useState(false);
  const [removeId, setRemoveId] = useState("");

  const removeCartItem = (cartID) => {
    setShowConfirmBox(true);
    setRemoveId(cartID);
  };

  const getCartCount = async () => {
    try {
      const res = isGuest ? await guest_get_cart_count() : await get_cart_count();
      if (res.status === 200) {
        setCartData(res.data.CartCount);
        if (!isGuest) localStorage.setItem("cartItemCount", res.data.CartCount);
      }
    } catch (error) {
      console.error("Error fetching cart count:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      isGuest
        ? await guest_addtocart_delete_api(id)
        : await addtocart_delete_api(id);

      const updated = api_data
        .map((item) => ({ ...item, Carts: item.Carts.filter((c) => c.CartID !== id) }))
        .filter((item) => item.Carts.length > 0);
      setapi_data(updated);
      await getCartCount();
      setShowConfirmBox(false);
    } catch (error) {
      console.error("Error removing cart item:", error);
    }
  };

  const [gstRate, setGSTRate] = useState(0);
  const [cartid2, setcartid2] = useState(0);

  const fetchGST = async () => {
    try {
      const GSTData = isGuest ? await guest_gstdata_get_api() : await gstdata_get_api();
      setGSTRate(parseFloat(GSTData.Data.Rate));
    } catch (error) {
      console.error("Error fetching GST:", error);
    }
  };

  const getImageUrl = (item) =>
    process.env.REACT_APP_API_URL + item.ProductImage ||
    process.env.REACT_APP_API_URL + "default.jpg";

  const calculateSubtotal = (item) => {
    const subtotal = item.Carts.reduce((total, c) => {
      return total + (c.QTY || 0) * (parseFloat(c.BasePrice) || 0);
    }, 0);
    return subtotal.toFixed(2);
  };

  const calculateGST = (subtotal) => (subtotal * (gstRate / 100)).toFixed(2);

  const [descriptionInput, setDescriptionInput] = useState({});
  const [selectedFiles, setSelectedFiles] = useState({});

  const toggleDescriptionEdit = (cartId) => {
    setDescriptionInput((prev) => ({
      ...prev,
      [cartId]: { enabled: !prev[cartId]?.enabled, value: prev[cartId]?.value || "" },
    }));
  };
  const handleDescriptionChange = (cartId, value) => {
    setDescriptionInput((prev) => ({ ...prev, [cartId]: { ...prev[cartId], value } }));
  };

  const handleDescriptionUpload = async (cartId, descriptionValue) => {
    try {
      const res = isGuest
        ? await guest_cart_description_api({ GuestCartID: cartId, Brief: descriptionValue })
        : await cart_description_api({ CartID: cartId, Brief: descriptionValue });
      handleExceptionSuccessMessages(res);
      handleDescriptionChange(cartId, "");
    } catch (error) {
      console.error("Error uploading description:", error);
      handleExceptionError("Error uploading description.");
    }
  };

  const handleFileSelection = async (cartId, files) => {
    const newFile = Array.from(files);
    const targetId = cartid2 !== 0 ? cartid2 : cartId;
    setSelectedFiles((prev) => ({ ...prev, [targetId]: newFile }));
    setcartid2(0);
    const fileObject = newFile.reduce((obj, file, index) => { obj[index] = file; return obj; }, {});

    try {
      const requestParams = isGuest
        ? { GuestCartID: targetId, CartAttachments: fileObject }
        : { CartID: targetId, CartAttachments: fileObject };

      console.log('requestParams', requestParams)
      const response = isGuest
        ? await guest_cart_artwork_api(requestParams)
        : await cart_artwork_api(requestParams);

      setapi_data((prev) =>
        prev.map((item) => {
          if (item.Carts?.some((c) => c.CartID === targetId)) {
            const attachKey = isGuest ? "GuestCartAttachment" : "cartAttachment";
            const newAttach = (response[attachKey] || []).map((a) => ({
              CartAttachmentID: a.GuestCartAttachmentID || a.CartAttachmentID,
              Attachment: a.Attachment,
            }));
            // Only touch the line that was edited – the same product can have several lines
            return {
              ...item,
              Carts: item.Carts.map((c) =>
                c.CartID === targetId ? { ...c, CartAttachment: newAttach } : c
              ),
            };
          }
          return item;
        })
      );
      fetchData();
    } catch (error) {
      console.error("Error uploading artwork:", error);
    }
  };

  const handleArtworkUpload = (cartId) => {
    fileInputRef.current.click();
    setcartid2(cartId);
  };

  const imageDelete = async (cartID, i, isCartAttachment, CartAttachmentID) => {
    isGuest
      ? await guest_delete_artwork_api(cartID, CartAttachmentID)
      : await delete_artwork_api(cartID, CartAttachmentID);

    setapi_data((prev) =>
      prev.map((item) => {
        if (item.Carts.some((c) => c.CartID === cartID)) {
          return {
            ...item,
            Carts: item.Carts.map((c) => {
              if (c.CartID === cartID) {
                return {
                  ...c,
                  CartAttachment: c.CartAttachment.filter(
                    (a) => a.CartAttachmentID !== CartAttachmentID
                  ),
                };
              }
              return c;
            }),
          };
        }
        return item;
      })
    );
  };

  return (
    <div>
      {showConfirmBox && (
        <Alert
          message="Are you sure you want to remove this item from the cart?"
          showConfirmBox={showConfirmBox}
          setShowConfirmBox={setShowConfirmBox}
          onConfirm={handleDelete}
          id={removeId}
        />
      )}

      <ErrorSnackbar
        errorMessages={ExceptionError}
        onClearErrors={clearErrors}
      />
      <SuccessSnackbar
        successMessages={successMessages}
        onclearSuccess={clearSuccess}
      />
      <Head_CateHead />
      <div className="container">
        <Slide_title title="Shopping Cart" className="category_title cart" />
        <hr />
        <div className="cart_wrap">
          {cartLoading ? <CartSkeleton /> : ( <>
          {
            <div className="cart_list">
              {api_data.length > 0 ? (
                <>
                  {" "}
                  {api_data?.map((item) => {
                    return (
                      <>
                        {item.Carts.length > 0 &&
                          item.Carts.map((cartItem, index) => {
                            return (
                              <div
                                className="cart_item"
                                key={cartItem.CartID ?? `${cartItem.ProductID}-${index}`}
                                style={{ marginRight: "1vw" }}
                              >
                                <div className="cart_img">
                                  {/* Use item.ProductImage here */}
                                  <Link to={`/product/${item.Slug}`}>
                                    <img
                                      src={getImageUrl(item)}
                                      alt={cartItem.ProductName}
                                    />
                                  </Link>
                                </div>
                                <div className="cart_info">
                                  <div className="cart_info1">
                                    <div className="cart_detail">
                                      <div className="cart_title">
                                        <h3>
                                          <Link
                                            to={`/product/${item.Slug}`}
                                            style={{ color: "inherit" }}
                                          >
                                            {cartItem.ProductName}
                                          </Link>
                                        </h3>
                                        <CartVariationInfo cartItem={cartItem} />
                                        {cartItem.randomnumber != "" &&
                                          cartItem.randomnumber != null && (
                                            <p style={{ width: "300px" }}>
                                              {cartItem?.randomnumber?.map(
                                                (randomnumber, i) => {
                                                  return (
                                                    <span
                                                      className="sm-txt"
                                                      key={i}
                                                    >
                                                      {randomnumber.name}(
                                                      {randomnumber.value}){" "}
                                                    </span>
                                                  );
                                                }
                                              )}
                                            </p>
                                          )}
                                        {cartItem?.CartSetupPrice?.length >
                                          0 && (
                                            <>
                                              <h3 style={{ marginTop: "12px" }}>
                                                Additional Cost:
                                              </h3>
                                              <p>
                                                {cartItem.CartSetupPrice.filter(
                                                  (setp) =>
                                                    parseFloat(setp.QTY) > 0
                                                ).map((setp, i) => (
                                                  <span
                                                    className="sm-txt"
                                                    key={i}
                                                  >
                                                    {
                                                      setp.ProductSetupPrice
                                                        .SetupName
                                                    }{" "}
                                                    ({parseFloat(setp.QTY)}){" "}
                                                  </span>
                                                ))}
                                              </p>
                                            </>
                                          )}
                                        {/* Use ProductDescription here */}
                                        {/* <div dangerouslySetInnerHTML={{ __html: item.ProductDescription }} /> */}
                                      </div>
                                      <div className="cart_count ">
                                        {/* <button className="">-</button> */}
                                        <h5>
                                          QTY: {cartItem.QTY} X $
                                          {cartItem.BasePrice}
                                        </h5>
                                        {/* <button className="">+</button> */}
                                      </div>
                                      <div className="cart_price">
                                        <h5>
                                          $
                                          {(
                                            cartItem.BasePrice * cartItem.QTY
                                          ).toFixed(2)}
                                        </h5>
                                      </div>
                                    </div>
                                  </div>
                                  {/* ShirtDescription — full width below image/title/price row */}
                                  {cartItem.ShirtDescription && (() => {
                                    let parsed = null;
                                    try {
                                      parsed = typeof cartItem.ShirtDescription === "string"
                                        ? JSON.parse(cartItem.ShirtDescription)
                                        : cartItem.ShirtDescription;
                                    } catch (e) { return null; }
                                    // Support both new {teamName, players} and legacy flat array
                                    const teamName = parsed && !Array.isArray(parsed) && parsed.teamName ? parsed.teamName : "";
                                    const shirtRows = parsed && !Array.isArray(parsed) && Array.isArray(parsed.players)
                                      ? parsed.players
                                      : Array.isArray(parsed) ? parsed : [];
                                    if (shirtRows.length === 0) return null;
                                    const isExpanded = !!expandedShirt[cartItem.CartID];
                                    const visibleRows = isExpanded ? shirtRows : shirtRows.slice(0, 5);
                                    return (
                                      <div style={{ width: "100%", marginTop: "10px", marginBottom: "6px" }}>
                                        {teamName && (
                                          <p style={{ fontFamily: "Poppins", fontSize: "0.85rem", fontWeight: "600", marginBottom: "6px", color: "#333" }}>
                                            Team Name: <span style={{ fontWeight: "400", color: "#555" }}>{teamName}</span>
                                          </p>
                                        )}
                                        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.8rem", fontFamily: "Poppins" }}>
                                          <thead>
                                            <tr style={{ background: "rgba(3,128,176,0.08)" }}>
                                              <th style={{ padding: "5px 8px", textAlign: "left", fontWeight: "600", borderBottom: "1px solid #ddd" }}>Variation</th>
                                              <th style={{ padding: "5px 8px", textAlign: "left", fontWeight: "600", borderBottom: "1px solid #ddd" }}>Name</th>
                                              <th style={{ padding: "5px 8px", textAlign: "left", fontWeight: "600", borderBottom: "1px solid #ddd" }}>Number</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {visibleRows.map((row, ri) => (
                                              <tr key={ri} style={{ borderBottom: "1px solid #f0f0f0" }}>
                                                <td style={{ padding: "4px 8px", color: "#555" }}>{row.variation}</td>
                                                <td style={{ padding: "4px 8px", color: "#555" }}>{row.name}</td>
                                                <td style={{ padding: "4px 8px", color: "#555" }}>{row.number}</td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                        {shirtRows.length > 5 && (
                                          <span
                                            className="txt_read_more"
                                            style={{ cursor: "pointer", fontSize: "0.8rem", fontFamily: "Poppins" }}
                                            onClick={() =>
                                              setExpandedShirt((prev) => ({
                                                ...prev,
                                                [cartItem.CartID]: !prev[cartItem.CartID],
                                              }))
                                            }
                                          >
                                            {isExpanded ? "Read Less" : `+${shirtRows.length - 5} more... Read More`}
                                          </span>
                                        )}
                                      </div>
                                    );
                                  })()}
                                  {/* Custom Popup Details */}
                                  {cartItem.custompopup && (() => {
                                    let parsed = null;
                                    try {
                                      parsed = typeof cartItem.custompopup === "string"
                                        ? JSON.parse(cartItem.custompopup)
                                        : cartItem.custompopup;
                                    } catch (e) { return null; }
                                    if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
                                    const entries = Object.entries(parsed);
                                    if (entries.length === 0) return null;
                                    return (
                                      <div style={{ width: "100%", marginTop: "10px", marginBottom: "6px", background: "#f9f9f9", borderRadius: "6px", padding: "10px 12px" }}>
                                        <p style={{ fontFamily: "Poppins", fontSize: "0.85rem", fontWeight: "600", marginBottom: "8px", color: "#333" }}>
                                          Custom Details:
                                        </p>
                                        {entries.map(([key, val], i) => (
                                          <div key={i} style={{ display: "flex", gap: "8px", marginBottom: "4px", fontFamily: "Poppins", fontSize: "0.8rem" }}>
                                            <span style={{ fontWeight: "500", color: "#444", minWidth: "120px" }}>{key}:</span>
                                            <span style={{ color: "#555" }}>
                                              {typeof val === "boolean" ? (val ? "✓ Yes" : "✗ No") : String(val)}
                                            </span>
                                          </div>
                                        ))}
                                      </div>
                                    );
                                  })()}

                                  <div className="cart_info2">
                                    <div className="left_side_button">
                                      <button
                                        className={"cart_info2_bt1" + " "}
                                        onClick={() =>
                                          handleArtworkUpload(cartItem.CartID)
                                        }
                                      >
                                        <img src={upload} alt="" />
                                        Artwork
                                      </button>
                                      <input
                                        ref={fileInputRef}
                                        className="mt-2"
                                        type="file"
                                        multiple
                                        style={{ display: "none" }}
                                        accept="image/*,application/pdf"
                                        onChange={(e) =>
                                          handleFileSelection(
                                            cartItem?.CartID,
                                            e.target.files
                                          )
                                        }
                                      />

                                      <button
                                        className="cart_info2_bt2"
                                        onClick={() =>
                                          toggleDescriptionEdit(cartItem.CartID)
                                        }
                                      >
                                        <img src={disc} alt="disc" />
                                        Description
                                      </button>
                                    </div>
                                    <div className="right_side_button">
                                      <Link
                                        to={`/product/${item.Slug}?edit=${cartItem.CartID}`}
                                        className="cart_info2_bt3"
                                        style={{
                                          "texDdecoration": "none",
                                          "display": "block",
                                          "text-align": "center",
                                          "width": "auto",
                                          "padding": "3px 20px",
                                          "margin-right": "5px",
                                        }}
                                        title="Change size, colour or other options"
                                      >
                                        Edit
                                      </Link>
                                      <button
                                        className="cart_info2_bt3"
                                        onClick={() =>
                                          removeCartItem(cartItem.CartID)
                                        }
                                      >
                                        <img src={remove} alt="remove" />
                                        Remove
                                      </button>
                                    </div>
                                  </div>
                                  <div
                                    className="allImage"
                                    style={{
                                      marginTop: "1vw",
                                      marginBottom: "1vw",
                                    }}
                                  >
                                    {cartItem?.CartAttachment?.map((img, i) => (
                                      <>
                                        <div className="artwork_image">
                                          <img
                                            className="h-w-100"
                                            src={
                                              img.Attachment.endsWith(".pdf")
                                                ? PdfIcon
                                                : "https://api.bebranded.com.au/" +
                                                img.Attachment
                                            }
                                            alt="attachment"
                                          />

                                          <div
                                            className="delete_selected_mage"
                                            onClick={() =>
                                              imageDelete(
                                                cartItem.CartID,
                                                i,
                                                true,
                                                img.CartAttachmentID
                                              )
                                            }
                                          >
                                            x
                                          </div>
                                        </div>
                                      </>
                                    ))}
                                  </div>
                                  {descriptionInput[cartItem.CartID]
                                    ?.enabled && (
                                      <div className="description_editor mt-2">
                                        <textarea
                                          value={
                                            descriptionInput[cartItem.CartID]
                                              ?.value != ""
                                              ? descriptionInput[cartItem.CartID]
                                                ?.value
                                              : cartItem.Brief
                                          }
                                          onChange={(e) =>
                                            handleDescriptionChange(
                                              cartItem.CartID,
                                              e.target.value
                                            )
                                          }
                                        />
                                        <br></br>
                                        <button
                                          className="cart_info2_bt3"
                                          onClick={() =>
                                            handleDescriptionUpload(
                                              cartItem.CartID,
                                              descriptionInput[cartItem.CartID]
                                                ?.value || ""
                                            )
                                          }
                                        >
                                          Upload Description
                                        </button>
                                      </div>
                                    )}
                                </div>
                              </div>
                            );
                          })}
                      </>
                    );
                  })}
                </>
              ) : (
                <div className="empty_crt">
                  <h3>Please add items to your cart.</h3>
                  <div>
                    <Link to="/">
                      <button> Go to Home</button>
                    </Link>
                  </div>
                </div>
              )}
            </div>
          }
          <div className="cart_total">
            <div className="cart_title">
              <h3>Order Summary</h3>
            </div>
            <div className="cart_total_list">
              <div className="cart_count1">
                <h3>Subtotal</h3>
                <h4>
                  $
                  {api_data
                    ?.reduce(
                      (total, item) =>
                        total + parseFloat(calculateSubtotal(item)),
                      0
                    )
                    .toFixed(2)}
                </h4>
              </div>
              <hr className="cart_total_hr" />
              <div className="cart_count1">
                <h3>GST ({gstRate.toFixed(2)}%)</h3>
                <h4>
                  $
                  {calculateGST(
                    api_data?.reduce(
                      (total, item) =>
                        total + parseFloat(calculateSubtotal(item)),
                      0
                    )
                  )}
                </h4>
              </div>
              <hr className="cart_total_hr" />
              <div className="cart_count1">
                <h3>Order total</h3>
                <h4>
                  $
                  {(
                    parseFloat(
                      api_data?.reduce(
                        (total, item) =>
                          total + parseFloat(calculateSubtotal(item)),
                        0
                      )
                    ) +
                    parseFloat(
                      calculateGST(
                        api_data?.reduce(
                          (total, item) =>
                            total + parseFloat(calculateSubtotal(item)),
                          0
                        )
                      )
                    )
                  ).toFixed(2)}
                </h4>
              </div>
            </div>
            {api_data.length === 0 ? (
              <div>
                <p>Please add items to your cart.</p>
                <Link to="/">
                  <button> Go to Home</button>
                </Link>
              </div>
            ) : (
              // Render the checkout button if api_data is not empty
              <Link to="/checkout">
                <button>Checkout</button>
              </Link>
            )}
            <p>
              Learn more <a href="#">Taxes</a> and <a href="#">Shipping</a>{" "}
              information
            </p>
          </div>
          </> )}
        </div>
      </div>
      <Footer />
    </div>
  );
};
